import { useFetch } from '@/hooks/useFetch'

export const useIndexerLog = (productId: number, isActive = true) =>
  useFetch<string>(
    ({ account }) =>
      `/api/proxy/catalog/pvt/admin/product/${productId}/indexer/log?an=${account}`,
    { json: false, isActive }
  )
